import {
  customStyles,
  customStylesFilter,
} from "@components/Select/customStyles";
import React from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.css";
import colors from "../../../colors";

export const FilterInput = ({
  label,
  value,
  id,
  onChange,
  error,
  placeholder,
  onKeyDown,
  fieldsetId,
  ...restProps
}) => {
  const handleFocus = () => {
    const fieldset = document.getElementById(fieldsetId);
    const label = document.getElementById(`${fieldsetId}_label`);
    if (fieldset) {
      fieldset.style.borderColor = colors.primary;
    }
    if (label) {
      label.style.color = colors.primary;
    }
  };

  const handleBlur = () => {
    const fieldset = document.getElementById(fieldsetId);
    const label = document.getElementById(`${fieldsetId}_label`);
    if (fieldset) {
      fieldset.style.borderColor = colors.gray["300"];
    }
    if (label) {
      label.style.color = "black";
    }
  };

  return (
    <fieldset
      className='border border-gray-300 focus:border-primary h-[45.5px]'
      id={fieldsetId}
    >
      <legend id={`${fieldsetId}_label`} className='text-[12.5px] ml-1.5 px-1'>
        {label}
      </legend>
      <input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        className='w-full outline-none px-2 pt-[2.5px] text-sm'
        onFocus={handleFocus}
        onBlur={handleBlur}
        {...restProps}
      />
    </fieldset>
  );
};

export const FilterSelect = ({
  label,
  options,
  value,
  placeholder,
  onChange,
  styles,
  fieldsetId,
  id,
  defaultValue,
  isMulti,
  ...restProps
}) => {
  console.log("value", value);
  const handleFocus = () => {
    const fieldset = document.getElementById(fieldsetId);
    const label = document.getElementById(`${fieldsetId}_label`);
    if (fieldset && label) {
      fieldset.style.borderColor = colors.primary;
      label.style.color = colors.primary;
    }
  };

  const handleBlur = () => {
    const fieldset = document.getElementById(fieldsetId);
    const label = document.getElementById(`${fieldsetId}_label`);
    if (fieldset && label) {
      fieldset.style.borderColor = colors.gray["300"];
      label.style.color = "black";
    }
  };

  const modifiedOptions =
    id === "finds_status" && defaultValue?.length
      ? options.filter(
          (opt) => !defaultValue.some((def) => def.value === opt.value)
        )
      : options;

  const modifiedValue =
    id === "finds_status" &&
    Array.isArray(value) &&
    value.length > 1 &&
    defaultValue?.length
      ? value.filter(
          (val) => !defaultValue.some((def) => def.value === val.value)
        )
      : value;
  console.log("modifiedValue", modifiedValue);
  const handleChange = (selected) => {
    let newValue = selected;
    console.log("selected", selected);

    if (
      id === "finds_status" &&
      Array.isArray(selected) &&
      selected.length > 1 &&
      defaultValue?.length
    ) {
      newValue = selected.filter(
        (val) => !defaultValue.some((def) => def.value === val.value)
      );
    }

    console.log("newValue", newValue);

    onChange(newValue);
  };

  return (
    <fieldset
      className='border border-gray-300 focus:border-primary '
      id={fieldsetId}
    >
      <legend id={`${fieldsetId}_label`} className='text-[12.5px] ml-1.5 px-1'>
        {label}
      </legend>
      <Select
        options={modifiedOptions}
        value={modifiedValue}
        placeholder={placeholder}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        styles={styles ?? customStylesFilter}
        defaultValue={defaultValue}
        isMulti={isMulti}
        {...restProps}
      />
    </fieldset>
  );
};

export const FilterDate = ({
  label,
  name,
  selected,
  onChange,
  fieldsetId,
  ...restProps
}) => {
  const handleFocus = () => {
    const fieldset = document.getElementById(fieldsetId);
    const label = document.getElementById(`${fieldsetId}_label`);
    if (fieldset && label) {
      fieldset.style.borderColor = colors.primary;
      label.style.color = colors.primary;
    }
  };

  const handleBlur = () => {
    const fieldset = document.getElementById(fieldsetId);
    const label = document.getElementById(`${fieldsetId}_label`);
    if (fieldset && label) {
      fieldset.style.borderColor = colors.gray["300"];
      label.style.color = "black";
    }
  };

  return (
    <fieldset
      className='border border-gray-300 focus:border-primary'
      id={fieldsetId}
    >
      <legend id={`${fieldsetId}_label`} className='text-[12.5px] ml-1.5 px-1'>
        {label}
      </legend>
      <DatePicker
        id={name}
        className='outline-none w-full py-[7px] pl-2'
        selected={selected}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        isClearable
        {...restProps}
      />
    </fieldset>
  );
};
